import { network } from './network';

export async function getDashboardData(params) {
	const { start_time, end_time, granularity, user_name, secret_key } = params;
	const res = await network({
		url: '/api/dashboard_query',
		method: 'post',
		params: {
			start_time,
			end_time,
			granularity,
			user_name,
			secret_key
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}